import React, { useState, useEffect, useMemo, createRef, useCallback } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Select from 'react-select';

const getArticles = (props, query, setArticles) => {
  const authorizedScope = `q[organization_id_eq]=${props.organization.id}&`
  return fetch(props.articles_path + `?` + authorizedScope + query.replace(/\n/g,"&"))
    .then(res => res.json())
    .then(body => {
      if ( 'articles' in body ) {
        return body
      } else {
        return Promise.reject()
      }
    })
    .then(body => {
      if ( body.articles.length !== 0 ) {
        return body.articles
      } else {
        return []
      }
    })
    .then(articles => {
      return setArticles(articles)
    })
    .catch(err => {
      console.error(err)
    })
}

const NoOptionsMessage = () => {
  const msgStyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  };

  return (
    <h4 style={msgStyles}>条件に一致する物件がありません</h4>
  );
};

function ArticleCollectionTable(props) {
  return (
    <Select
      isMulti
      isClearable={false}
      options={props.articles && props.articles.map((app) => {
        return { value: app.id, label: app.id + ' ' + app.name }
      })}
      className="basic-multi-select"
      classNamePrefix="select"
      defaultValue={props.articles && props.articles.map((article) => {
        return { value: article.id, label: article.id + ' ' + article.name }
      })}
      onChange={(options) => {
        props.handleChange(options)
      }}
      components={{ NoOptionsMessage }}
      styles={{ noOptionsMessage: (base) => ({ ...base, ...msgStyles }) }}
      placeholder="▼ 選択してください"
    />
  )
}

function AppsSelector(props) {
  return (
    <Select
      isMulti
      isClearable={false}
      options={props.apps && props.apps.map((app) => {
        return { value: app.id, label: app.id + ' ' + app.name }
      })}
      className="basic-multi-select"
      classNamePrefix="select"
      defaultValue={props.apps && props.apps.map((app) => {
        if(props.checkedCorporates && props.checkedCorporates.includes(app.id)) {
          return { value: app.id, label: app.id + ' ' + app.name }
        }
      })}
      onChange={(options) => {
        props.handleChange(options)
      }}
      components={{ NoOptionsMessage }}
      styles={{ noOptionsMessage: (base) => ({ ...base, ...msgStyles }) }}
      placeholder="▼ 選択してください"
    />
  )
}

function TeamPermitArticleParamsFieldForm(props) {

  const [articles, setArticles] = useState([])
  const [checkedArticles, setCheckedArticles] = useState(props.q.article_id_in)
  const [checkedCorporates, setCheckedCorporates] = useState(props.selected_app_ids)

  useEffect(()=>{
    if ( conditionResultValue ) {
      getArticles(props, conditionResultValue, setArticles)
    } else {
      setArticles([])
      setCheckedArticles([])
    }
  },[checkedCorporates])

  const handleCheckedCorporatesChange = useCallback(options => {
    let value = [];
    if(options) {
      for (let i = 0, l = options.length; i < l; i++) {
          value.push(options[i].value);
      }
    }
    setCheckedCorporates(value)
  }, [checkedCorporates])

  const handleCheckedArticlesChange = useCallback((options) => {
    let value = [];
    if(options) {
      for (let i = 0, l = options.length; i < l; i++) {
          value.push(options[i].value);
      }
    }
    setCheckedArticles(value)
  }, [checkedArticles])

  const conditionResultValue = useMemo(() => {
    const result = []
    if ( checkedCorporates.length > 0 ){
      checkedCorporates.map( (value, index) => {
        result.push( "q[corporate_id_in][]=" + value )
      });
    }
    return result.join("\n")
  },[
    checkedCorporates
  ])
  const resultValue = useMemo(() => {
    const resultArticles = []
    if ( checkedArticles && checkedArticles.length > 0 ){
      checkedArticles.map( (value, index) => {
        resultArticles.push( "q[article_id_in][]=" + value )
      });
    }
    return conditionResultValue + "\n" + resultArticles.join("\n")
  },[checkedCorporates, checkedArticles])

  return (
    <Container className="TeamFieldFormContainer">
      <ResultFieldUnit>
        <LabelBox>
          物件検索条件
        </LabelBox>
        <FieldBox>
          <textarea name={props.name} value={resultValue} readOnly={true}></textarea>
        </FieldBox>
      </ResultFieldUnit>

      <FieldUnit>
        <LabelBox>
          アプリ
        </LabelBox>
        <FieldBox>
          <AppsSelector {...props} handleChange={handleCheckedCorporatesChange} checkedCorporates={checkedCorporates}/>
        </FieldBox>
      </FieldUnit>

      <FieldUnit>
        <LabelBox>
          物件選択
          <LabelHint>未選択：全物件対象</LabelHint>
        </LabelBox>
        <FieldBox>
          <ArticleCollectionTable
            {...props}
            query={conditionResultValue}
            articles={props.articles.concat(articles)}
            handleChange={handleCheckedArticlesChange}
            checkedArticles={checkedArticles}
            />
        </FieldBox>
      </FieldUnit>

    </Container>
  )
}

TeamPermitArticleParamsFieldForm.propTypes = {
  prefecture_areas: PropTypes.object,
  q: PropTypes.object,
  name: PropTypes.string.isRequired,
  organization: PropTypes.object,
}

export default TeamPermitArticleParamsFieldForm

const Container = styled.div`
  display: flex;
  flex-flow: column wrap;
  width: 100%;
`
const FieldUnit = styled.div`
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  margin-bottom: 1.5em;
`
const ResultFieldUnit = styled(FieldUnit)`
  display: none;
`
const LabelBox = styled.div`
  flex-grow: 1;
  width: calc(15% - 1rem);
  margin-left: 1rem;
  text-align: right;
  font-weight: bold;
`
const LabelHint = styled.p`
  font-size: 0.8em;
  font-weight: normal;
  color: #999;
`
const FieldBox = styled.div`
  flex-grow: 1;
  margin-left: 2rem;
  width: 100%;
  max-width: 50rem;
  label {
    display: inline-block;
    margin-right: 2em;
    font-weight: normal;
  }
  input[type=number] {
    width: 10em;
    display: inline-block;
    margin-right: 0.5em;
  }
`
const PrefectureFieldBox = styled(FieldBox)`
  table {
    th {
      font-weight: normal;
      white-space: nowrap;
    }
    td {
      display: flex;
      flex-flow: row wrap;
      input {
        display: inline-block;
      }
      label {
        font-weight: normal;
        display: inline-block;
        padding-right: 1em;
        cursor: pointer;
      }
    }
  }
`
const NumberRangeFieldBox = styled(FieldBox)`
`
const ZipFieldBox = styled(FieldBox)`
  textarea {
    width: 20em;
    min-height: 10em;
    display: inline-block;
  }
`

const ArticleCollectionContainer = styled.div`

`
